/**
 * Los emojis en español se bajan recién cuando alguien abre el selector: son unos 400 KB de datos (Unicode/CLDR, paquete
 * `emojibase-data`) que el resto del panel no usa. Con `?url` Vite los publica como un archivo aparte y no van en el JS.
 * Un pedido que falla se puede reintentar; uno que salió queda para la próxima vez que se abra.
 */
import urlEmojis from "emojibase-data/es/compact.json?url";
import urlMensajes from "emojibase-data/es/messages.json?url";
import { agrupar, type EmojiCompacto, type GrupoEmojis, type MensajesEmojis } from "./emojis";

let pedido: Promise<GrupoEmojis[]> | null = null;

const json = async (url: string): Promise<unknown> => {
  const r = await fetch(url);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
};

export function cargarEmojis(): Promise<GrupoEmojis[]> {
  if (!pedido) {
    pedido = Promise.all([json(urlEmojis), json(urlMensajes)])
      .then(([emojis, mensajes]) => agrupar(emojis as EmojiCompacto[], mensajes as MensajesEmojis))
      .catch((e) => {
        pedido = null;
        throw e;
      });
  }
  return pedido;
}
